const DRAFT_PREFIX = "7cut.draft.";
const OUTBOX_PREFIX = "7cut.outbox.";
const STALE_MS = 30 * 24 * 60 * 60 * 1000; // 30 дней

const safeParse = (raw, fallback) => {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw);
  } catch (e) {
    return fallback;
  }
};

export const draftKey = (versionId) => `${DRAFT_PREFIX}${versionId}`;
export const outboxKey = (versionId) => `${OUTBOX_PREFIX}${versionId}`;

export const readDraft = (versionId) =>
  safeParse(localStorage.getItem(draftKey(versionId)), null);

export const writeDraft = (versionId, draft) => {
  localStorage.setItem(
    draftKey(versionId),
    JSON.stringify({ ...draft, savedAt: Date.now() })
  );
};

export const clearDraft = (versionId) => {
  localStorage.removeItem(draftKey(versionId));
};

export const isDraftEmpty = (draft) =>
  !draft ||
  ((!draft.text || !draft.text.trim()) &&
    !(draft.tagIds || []).length &&
    !draft.newMarkerInfo);

export const readOutbox = (versionId) =>
  safeParse(localStorage.getItem(outboxKey(versionId)), []);

export const writeOutbox = (versionId, items) => {
  if (!items || !items.length) {
    localStorage.removeItem(outboxKey(versionId));
    return;
  }
  localStorage.setItem(
    outboxKey(versionId),
    JSON.stringify(items.map((item) => ({ ...item, savedAt: Date.now() })))
  );
};

export const cleanupStaleCommentStorage = () => {
  const now = Date.now();
  Object.keys(localStorage)
    .filter(
      (key) => key.startsWith(DRAFT_PREFIX) || key.startsWith(OUTBOX_PREFIX)
    )
    .forEach((key) => {
      const raw = safeParse(localStorage.getItem(key), null);

      const savedAt = Array.isArray(raw)
        ? Math.max(0, ...raw.map((item) => item?.savedAt || 0))
        : raw?.savedAt;

      if (!savedAt || now - savedAt > STALE_MS) localStorage.removeItem(key);
    });
};
